module.exports = __webpack_public_path__ + "img/level-icon-2.9e9aca32.png";